import { createRouter, createWebHashHistory } from 'vue-router'
import baseLayout from "../views/Layout/baselayout.vue"
import store from '../store'

const routes=[
    {
        path:'/',
        redirect:{name:'login'}
    },{
        path:'/login',
        name:'login',
        component:()=>import('../views/Login.vue'),
        meta:{
            title:'登录'
        }
    },{
        path:'/',
        component:baseLayout,
        children:[{
            path:'/home',
            name:'home',
            component:()=>import('../views/Home.vue'),
            meta:{
                title:'首页'
            }
        },{
            path:'/',
            name:'发票开具管理',
            children:[{
                path:'/ordersearch',
                name:'ordersearch',
                component:()=>import('../views/Fpkjgl/Ordersearch.vue'),
                meta:{
                    title:'订单查询'
                }
            },{
                path:'/kpsqcx',
                name:'kpsqcx',
                component:()=>import('../views/Fpkjgl/Kpsqcx.vue'),
                meta:{
                    title:'开票申请查询'
                }
            },{
                path:'/fpjlcx',
                name:'fpjlcx',
                component:()=>import('../views/Fpkjgl/Fpjlcx.vue'),
                meta:{
                    title:'发票记录查询'
                }
            },{
                path:'/hczfsqcl',
                name:'hczfsqcl',
                component:()=>import('../views/Fpkjgl/Hczfsqcl.vue'),
                meta:{
                    title:'红冲/作废申请处理'
                }
            },{
                path:'/yjcksqcl',
                name:'yjcksqcl',
                component:()=>import('../views/Fpkjgl/Yjcksqcl.vue'),
                meta:{
                    title:'一键重开申请处理'
                }
            },{
                path:'/fpkd',
                name:'fpkd',
                component:()=>import('../views/Fpkjgl/Fpkd.vue'),
                meta:{
                    title:'发票快递'
                }
            }]
        },{
            path:'/',
            name:'发票库存管理',
            children:[{
                path:'/stocksearch',
                name:'stocksearch',
                component:()=>import('../views/Fpkcgl/Stocksearch.vue'),
                meta:{
                    title:'库存查询'
                }
            },{
                path:'/fprk',
                name:'fprk',
                component:()=>import('../views/Fpkcgl/Fprk.vue'),
                meta:{
                    title:'发票入库'
                }
            },{
                path:'/fptk',
                name:'fptk',
                component:()=>import('../views/Fpkcgl/Fptk.vue'),
                meta:{
                    title:'发票退库'
                }
            },{
                path:'/fply',
                name:'fply',
                component:()=>import('../views/Fpkcgl/Fply.vue'),
                meta:{
                    title:'发票领用'
                }
            },{
                path:'/fpgh',
                name:'fpgh',
                component:()=>import('../views/Fpkcgl/Fpgh.vue'),
                meta:{
                    title:'发票归还'
                }
            },{
                path:'/kbfpzf',
                name:'kbfpzf',
                component:()=>import('../views/Fpkcgl/Kbfpzf.vue'),
                meta:{
                    title:'作废空白发票'
                }
            }]
        },{
            path:'/',
            name:'用户权限管理',
            children:[{
                path:'/userman',
                name:'userman',
                component:()=>import('../views/Userperman/Userman.vue'),
                meta:{
                    title:'用户管理'
                }
            },{
                path:'/roleandper',
                name:'roleandper',
                component:()=>import('../views/Userperman/Roleandper.vue'),
                meta:{
                    title:'角色及权限管理'
                }
            }]
        },{
            path:'/',
            name:'基础信息',
            children:[{
                path:'/mainbodyinform',
                name:'mainbodyinform',
                component:()=>import('../views/Baseinfo/Mainbodyinform.vue'),
                meta:{
                    title:'主体信息配置'
                }
            },{
                path:'/goodssbman',
                name:'goodssbman',
                component:()=>import('../views/Baseinfo/Goodssbman.vue'),
                meta:{
                    title:'商品税编管理'
                }
            },{
                path:'/skpman',
                name:'skpman',
                component:()=>import('../views/Baseinfo/Skpman.vue'),
                meta:{
                    title:'税控盘管理'
                }
            },{
                path:'/lobman',
                name:'lobman',
                component:()=>import('../views/Baseinfo/Lobman.vue'),
                meta:{
                    title:'LOB管理界面'
                }
            },{
                path:'/kplocationman',
                name:'kplocationman',
                component:()=>import('../views/Baseinfo/Kplocationman.vue'),
                meta:{
                    title:'开票Location信息查询'
                }
            },{
                path:'/advertssetinfo',
                name:'advertssetinfo',
                component:()=>import('../views/Baseinfo/Advertssetinfo.vue'),
                meta:{
                    title:'广告配置信息'
                }
            },{
                path:'/ywsygnman',
                name:'ywsygnman',
                component:()=>import('../views/Baseinfo/Ywsygnman.vue'),
                meta:{
                    title:'业务适用功能管理'
                }
            },{
                path:'/fpshjsyfwman',
                name:'fpshjsyfwman',
                component:()=>import('../views/Baseinfo/Fpshjsyfwman.vue'),
                meta:{
                    title:'发票审核及适用范围查询'
                }
            }]
        },{
            path:'/',
            name:'系统管理',
            children:[{
                path:'/systeminteraction',
                name:'systeminteraction',
                component:()=>import('../views/Systemman/Systeminteraction.vue'),
                meta:{
                    title:'系统交互日志'
                }
            },{
                path:'/searchlog',
                name:'searchlog',
                component:()=>import('../views/Systemman/Searchlog.vue'),
                meta:{
                    title:'操作日志查询'
                }
            },{
                path:'/platforminteraction',
                name:'platforminteraction',
                component:()=>import('../views/Systemman/Platforminteraction.vue'),
                meta:{
                    title:'平台交互查询'
                }
            },{
                path:'/setearlywarn',
                name:'setearlywarn',
                component:()=>import('../views/Systemman/Setearlywarn.vue'),
                meta:{
                    title:'预警设置'
                }
            },{
                path:'/searchearlywarn',
                name:'searchearlywarn',
                component:()=>import('../views/Systemman/Searchearlywarn.vue'),
                meta:{
                    title:'预警记录查询'
                }
            }]
        },{
            path:'/',
            name:'数据统计',
            children:[{
                path:'/kpdatacount',
                name:'kpdatacount',
                component:()=>import('../views/Datacount/Kpdatacount.vue'),
                meta:{
                    title:'开票数据统计'
                }
            },{
                path:'/fprecordcount',
                name:'fprecordcount',
                component:()=>import('../views/Datacount/Fprecordcount.vue'),
                meta:{
                    title:'发票记录统计'
                }
            },{
                path:'/yysjjk',
                name:'yysjjk',
                component:()=>import('../views/Datacount/Yysjjk.vue'),
                meta:{
                    title:'运营数据监控'
                }
            }]
        }]
    },

]

const router=createRouter({
    base:'/disney/backui',
    history:createWebHashHistory(),
    routes
})

router.beforeEach((to,from,next)=>{
    if(to.meta.title){
        document.title=to.meta.title
    }
    store.commit('setMenuclicknow',to.name)
    next()
})

export default router